<template>
  <div>
  <!-- NOTIFICATIONS -->
    <vs-dropdown vs-custom-content vs-trigger-click  ref="bellDrop" class="cursor-pointer">
      <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadNotifications.length" />

      <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

        <div class="notification-top text-center p-5 bg-primary text-white">
          <h3 class="text-white">{{ unreadNotifications.length == 1 ? `${unreadNotifications.length} Notificación` : `${unreadNotifications.length} Notificaciónes`}}</h3>
        </div>

        <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
          <ul class="bordered-items">
            <li v-for="ntf in notificationsList" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer" >
              <vs-row vs-w="9" class="flex" >
                <vs-col vs-type="" vs-justify="flex-end" vs-align="flex-end" vs-w="12">
                  <div class="flex items-start">
                    <feather-icon :icon="getIcon(ntf.notification_log.type)" :svgClasses="[`text-primary`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                    <div class="mx-2">
                      <span class="font-medium block notification-title" :class="ntf.read ? `text-secondary` : `text-primary` ">{{ ntf.notification_log.title }}</span>
                      <small> {{  !ntf.notification_log.message.substring(0,10).includes("<!") ? unicodeToChar(ntf.notification_log.message.substring(0, 198)) : 'Ver Correo' }}...</small>
                    </div>
                </div>
              </vs-col>
              </vs-row>
              <vs-row vs-w="3" class="flex">
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="12">
                    <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(new Date (ntf.notification_log.date)) }}</small>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="12">
                  <feather-icon icon="EyeIcon" class="mt-1 mr-2 whitespace-no-wrap" :svgClasses="[`text-primary`, 'stroke-current mr-1 h-6 w-6']"
                      @click="openNotif(ntf)" 
                    ></feather-icon>
                    <feather-icon v-if="!ntf.read" icon="CheckIcon" class="mt-1 whitespace-no-wrap" :svgClasses="[`text-success`, 'stroke-current mr-1 h-6 w-6']"
                       @click="markAsRead(ntf.id)"
                    ></feather-icon>
                </vs-col>
              </vs-row>
            </li>
          </ul>
        </component>

        <div v-if="false" class="
          checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 font-semibold text-center border 
          border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer">
          <span>Ver todas las notificaciones</span>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>
    <vs-popup class="" v-if="activeNotif.notification_log"  :title="activeNotif.notification_log.title" :active.sync="popupActive">
      <p v-if="activeNotif.notification_log.type == 'push'">
        {{activeNotif.notification_log.message}}
      </p>
      <div v-else-if="activeNotif.notification_log.type == 'email'" v-html="activeNotif.notification_log.message">
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      popupActive: false,
      activeNotif: {},
      isSecretary: false,
      unreadNotifications: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  beforeMount() {

    if(this.activeUserInfo.role !== "doctor" ){
        this.isSecretary = true;
        this.$store.dispatch('getDoctorDataById', sessionStorage.getItem('activeDoctorId')).then(response=>{
          console.log('DOCTOR: ',response);
          this.activeDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
        }, error => {
          console.error(error);
        });
      } else {
        this.isSecretary = false;
      }
  },
  mounted(){
    if(this.isSecretary){
      this.$store.dispatch('fetchNotifs', this.activeDoctorData.email);
    } else {
      this.$store.dispatch('fetchNotifs', this.activeUserInfo.email);
    }
    setTimeout(() => {
      console.log('NOTIFS_LIST: ',this.notificationsList);
    }, 1000);
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    notificationsList(){
      try {
        this.showNotif = new Array(this.$store.state.notifsList.length).fill(false);
        this.unreadNotifications = this.$store.state.notifsList.filter(notif => !notif.read);

        return this.$store.state.notifsList.reverse();
      } catch (error) {
        console.error(error);
        return [];
      }
      
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    markAsRead(id){
      // alert('mark as read');
      this.$store.dispatch('readNotification', id);
    },
    openNotif(notif){
      this.popupActive = true;
      console.log(notif);
      this.activeNotif = notif;
    },
    getIcon(type){
      if (type == 'email'){
        return 'MailIcon'
      } else {
        return 'MessageSquareIcon'
      }
    },
    unicodeToChar(text) {
      return text.replace(/\\u[\dA-F]{4}/gi, 
          function (match) {
               return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
          });
          },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Años ' : ' Año ')} atras`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Días ' : ' Día ')}atras`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hora ')}atras`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}atras`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' segundos' : 'justo ahora')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate ({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    }
  }
}

</script>

